// // import Icon from 'components/AppIcon';
// // import Button from 'components/ui/Button';
// // import React, { useState } from 'react';


// // const LoginForm = () => {
// //   const [showPassword, setShowPassword] = useState(false);
// //   const [formData, setFormData] = useState({
// //     phone: '',
// //     password: ''
// //   });

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData(prev => ({ ...prev, [name]: value }));
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     console.log('Login:', formData);
// //   };

// //   return (
// //     <form onSubmit={handleSubmit} className="space-y-5 font-[cairo]">

// //       {/* Phone */}
// //       <div className="space-y-2">
// //         <label className="block text-sm font-medium text-right">
// //           رقم الهاتف
// //         </label>
// //         <input
// //           type="tel"
// //           name="phone"
// //           value={formData.phone}
// //           onChange={handleChange}
// //           placeholder="05xxxxxxxx"
// //           className="w-full px-4 py-3 bg-input rounded-lg text-right border border-transparent
// // focus:border-red-500
// // focus:outline-none
// // focus:ring-0"
// //         />
// //       </div>

// //       {/* Password */}
// //       <div className="space-y-2">
// //         <label className="block text-sm font-medium text-right">
// //           كلمة المرور
// //         </label>

// //         <div className="relative">
// //           <input
// //             type={showPassword ? 'text' : 'password'}
// //             name="password"
// //             value={formData.password}
// //             onChange={handleChange}
// //             placeholder="أدخل كلمة المرور"
// //             className="w-full px-4 py-3 bg-input rounded-lg text-right border border-transparent
// // focus:border-red-500
// // focus:outline-none
// // focus:ring-0"
// //           />

// //           <button
// //             type="button"
// //             onClick={() => setShowPassword(!showPassword)}
// //             className="absolute left-4 top-1/2 -translate-y-1/2"
// //           >
// //             <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={20} />
// //           </button>
// //         </div>
// //       </div>

// //       <Button type="submit" size="lg" fullWidth className="mt-6 font-semibold">
// //         تسجيل الدخول
// //       </Button>
// //     </form>
// //   );
// // };


// // export default LoginForm;

// import React, { useState } from 'react';
// import Icon from 'components/AppIcon';
// import Button from 'components/ui/Button';
// import toast, { Toaster } from 'react-hot-toast';
// import { base_url } from 'Backend/api';
// import { useNavigate } from 'react-router-dom';

// const LoginForm = () => {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     phone: '',
//     password: ''
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const body = {
//       phone: formData.phone,
//       password: formData.password
//     };

//     try {
//       const res = await fetch(`${base_url}/api/login`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//         body: JSON.stringify(body),
//       });

//       const data = await res.json();

//       if (res.ok && data.status) {
//         // تسجيل الدخول ناجح
//         localStorage.setItem('user', JSON.stringify(data.data.user));
//         localStorage.setItem('token', data.data.token);
//         toast.success(data.message || 'تم تسجيل الدخول بنجاح');

//         // redirect للهوم بعد 1 ثانية
//         setTimeout(() => {
//           navigate('/restaurant-home-page');
//         }, 1000);
//       } else {
//         // رسائل الخطأ من الباك أند
//         if (data.message) {
//           toast.error(data.message);
//         } else {
//           toast.error('حدث خطأ، حاول مرة أخرى');
//         }
//       }
//     } catch (error) {
//       toast.error('حدث خطأ في الاتصال بالسيرفر');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Toaster
//         position="top-right"
//         reverseOrder={false}
//         toastOptions={{
//           style: {
//             fontFamily: 'Cairo, sans-serif',
//             fontWeight: '500',
//             fontSize: '14px',
//             textAlign: 'right',
//             direction: 'rtl',
//           },
//           success: { duration: 5000 },
//           error: { duration: 5000 },
//         }}
//       />
//       <form onSubmit={handleSubmit} className="space-y-5 font-[cairo]">

//         {/* Phone */}
//         <div className="space-y-2">
//           <label className="block text-sm font-medium text-right">رقم الهاتف</label>
//           <input
//             type="tel"
//             name="phone"
//             value={formData.phone}
//             onChange={handleChange}
//             placeholder="05xxxxxxxx"
//             className="w-full px-4 py-3 bg-input rounded-lg text-right border border-transparent focus:border-red-500 focus:outline-none focus:ring-0"
//           />
//         </div>

//         {/* Password */}
//         <div className="space-y-2">
//           <label className="block text-sm font-medium text-right">كلمة المرور</label>
//           <div className="relative">
//             <input
//               type={showPassword ? 'text' : 'password'}
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//               placeholder="أدخل كلمة المرور"
//               className="w-full px-4 py-3 bg-input rounded-lg text-right border border-transparent focus:border-red-500 focus:outline-none focus:ring-0"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword(!showPassword)}
//               className="absolute left-4 top-1/2 -translate-y-1/2"
//             >
//               <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={20} />
//             </button>
//           </div>
//         </div>

//         <Button
//           type="submit"
//           size="lg"
//           fullWidth
//           className="mt-6 font-semibold"
//           disabled={loading}
//         >
//           {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
//         </Button>
//       </form>
//     </>
//   );
// };

// export default LoginForm;
import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import toast, { Toaster } from 'react-hot-toast';
import { base_url } from 'Backend/api';
import { useNavigate } from 'react-router-dom';
import { getFcmToken } from 'getFcmToken';
import { registerFcmToken } from 'Backend/registerFcmToken';
import { validatePhoneNumber } from 'utils/validatePhoneNumber';

const LoginForm = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const [formData, setFormData] = useState({
    phone: '',
    password: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      setPhoneError('');
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const phoneValidationError = validatePhoneNumber(formData.phone);
    if (phoneValidationError) {
      setPhoneError(phoneValidationError);
      toast.error(phoneValidationError);
      return;
    }

    setLoading(true);

    const body = {
      phone: formData.phone.trim(),
      password: formData.password
    };

    try {
      const res = await fetch(`${base_url}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (res.ok && data.status) {
        localStorage.setItem('user', JSON.stringify(data.data.user));
        localStorage.setItem('token', data.data.token);
        localStorage.setItem('phone', data.data.user.phone);
        localStorage.setItem('slug', data.data.user.slug);
        toast.success(data.message || 'تم تسجيل الدخول بنجاح');
        setTimeout(() => navigate('/restaurant-home-page'), 1000);
        const fcmToken = await getFcmToken();

        if (fcmToken) {
          await registerFcmToken(fcmToken, token);
        }
      } else {
        toast.error(data.message || 'حدث خطأ، حاول مرة أخرى');
      }
    } catch (error) {
      // toast.error('حدث خطأ في الاتصال بالسيرفر');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            fontFamily: 'Cairo, sans-serif',
            fontWeight: '500',
            fontSize: '14px',
            textAlign: 'right',
            direction: 'rtl',
          },
          success: { duration: 5000 },
          error: { duration: 5000 },
        }}
      />

      <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5 font-[cairo] px-3 md:px-4">

        {/* Phone */}
        <div className="space-y-1 md:space-y-2">
          <label htmlFor="login-phone" className="block text-sm md:text-base font-medium text-right">
            <span>رقم الهاتف</span>
            <span className="mr-1 text-[#F93209]">*</span>
          </label>
          <input
            id="login-phone"
            type="tel"
            name="phone"
            autoComplete="tel"
            inputMode="tel"
            value={formData.phone}
            onChange={handleChange}
            onBlur={() => setPhoneError(validatePhoneNumber(formData.phone) || '')}
            placeholder="09xxxxxxxx"
            className={`w-full px-3 md:px-4 py-2.5 md:py-3 rounded-[8px] text-right border focus:border-red-500 focus:outline-none focus:ring-0 text-sm md:text-base ${
              phoneError ? 'border-red-500' : 'border-[#E5E7EB]'
            }`}
          />
          {phoneError && (
            <p className="text-right text-xs text-red-500">{phoneError}</p>
          )}
        </div>

        {/* Password */}
        <div className="space-y-1 md:space-y-2">
          <label htmlFor="login-password" className="block text-sm md:text-base font-medium text-right">
            <span>كلمة المرور</span>
            <span className="mr-1 text-[#F93209]">*</span>
          </label>
          <div className="relative">
            <input
              id="login-password"
              type={showPassword ? 'text' : 'password'}
              name="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              placeholder="أدخل كلمة المرور"
              className="w-full px-3 md:px-4 py-2.5 md:py-3  rounded-[8px] text-right border border-[#E5E7EB] focus:border-red-500 focus:outline-none focus:ring-0 text-sm md:text-base"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2"
            >
              <Icon color='#9CA3AF' name={showPassword ? 'EyeOff' : 'Eye'} size={20} />
            </button>
          </div>
        </div>

        <Button
          type="submit"
          size="lg"
          fullWidth
          className="mt-4 md:mt-6 font-medium text-sm md:text-base rounded-[8px]"
          disabled={loading}
        >
          {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
        </Button>
      </form>
    </>
  );
};

export default LoginForm;